export const environment = {
  production: false,
  environmentName: 'development',
  apiUrl: 'https://onlinebe.odt.ly',
  // apiUrl: 'https://testonlinebe.methaqins-ly.ly',
  printTemplate: 'legacy',
  enableConsole: false,
};